<!-- <div > -->
    <!-- style="position: fixed; z-index: 2147483647; bottom: 20px; right: 20px;" -->
    <!-- <div class="floating-icon">
        <div id="open-chat-icon"
          style="display: flex; justify-content: center; align-items: center; cursor: pointer; border-radius: 100%;"
          (click)="openChatModal()">
          <div
            style="height: 55px; width: 55px; cursor: pointer; border-radius: 100%; background-image: url('/assets/images/Bot.svg'); background-size: cover; background-repeat: no-repeat; background-position: center center;">
          </div>
        </div>
    

    </div> -->
            <!-- Close Chat Icon -->
        <!-- <div id="close-chat-icon"
            style="display: none; justify-content: center; align-items: center; cursor: pointer; border-radius: 100%;"
            (click)="closeChatModal()">
            <div
                style="height: 55px; width: 55px; cursor: pointer; border-radius: 100%; display: flex; justify-content: center; align-items: center; background-color: rgb(39, 39, 39);">
                <i data-feather="x" appFeatherIcon style="color: white; width: 18px; height: 18px;"></i>
            </div>
        </div> -->
    <!-- Chat Modal -->
    <div *ngIf="isChatModalOpen" class="modal-overlay ask-deja-chat">
        <div class="modal-content">
          <div class="modalHeader d-flex align-items-center justify-content-between text-white">
            <span class="text-bold">Ask Deja - Analytics Made Easy</span>
            <div>
                <button type="button" class="btn btn-dark text-white"(click)="clearChat()"> New Chat </button>
                <button class="btn text-white" style="margin: -14px 4px; font-size: 30px;" (click)="closeChatModal()" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
          </div>
          <app-chatbot [leftPanel]="false"></app-chatbot>
    
        
        </div>
    </div>
    
<!-- </div> -->





